<template>
    <div>
        <p>Loading... <a href="https://discord.com/invite/PBqQT9C">Dont work? click here</a></p>
    </div>
</template>

<script>
    export default {
        name: "Discord"
    }
    window.location.href = "https://discord.com/invite/PBqQT9C";

</script>

<style scoped>

</style>